import { render, staticRenderFns } from "./MandatsByAgency.vue?vue&type=template&id=2fe33778&"
import script from "./MandatsByAgency.vue?vue&type=script&lang=js&"
export * from "./MandatsByAgency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports